import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';

import { RootReducer } from './reducers';
import rootSaga from './saga'

const sagaMiddleware = createSagaMiddleware();
const Store = createStore(RootReducer, {}, applyMiddleware(sagaMiddleware));

sagaMiddleware.run(rootSaga);

export default Store;